import React, { useEffect, useState, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import settings from "settings"
import { loadingStatus, getPayload } from "actions"
import fieldStatus from "helpers/fieldStatus"
import _ from "lodash"
import { Formik, Field, Form } from "formik"
import ReactSelect from "components/ReactSelect"
import { useHistory, useLocation } from "react-router-dom"
import NumberField from "components/NumberField"
import KeyValueField from "components/KeyValueField"
import submitData from "helpers/asyncSubmitData"
import Dropzone from "react-dropzone"
import getData from "helpers/asyncSubmitData"
import TextArea from "components/TextArea"
import { GridContextProvider, GridDropZone, GridItem, swap } from "react-grid-dnd"
import { toast } from "react-toastify"
import * as Yup from "yup"
import helpers from "helpers/helpers"
import request from "superagent"

function Floorplan(props) {
	const history = useHistory()
	let entryModel = {
		name: "",
		sqft: "",
		stories: "",
		beds: "",
		full_baths: "",
		half_baths: "",
		garage: "",
		description: "",
		files: "",
		classifications: [],
		base_prices: [],
	}
	const [images, setImages] = useState([])
	const [fields, setFields] = useState(_.clone(entryModel))
	const [loaded, setLoaded] = useState(false)

	const location = useLocation()

	let id = props.match.params.id
	useEffect(() => {
		retrieveData()
	}, [])

	const buildData = async (data) => {
		let images = data.files ? _.cloneDeep(data.files) : []
		setImages(images)
		let d = _.pickBy(data, (v, k) => {
			if (entryModel.hasOwnProperty(k)) return true
		})
		setFields(d)
		setLoaded(true)
	}

	const retrieveData = async () => {
		props.loadingStatus(true)
		return getData("getFloorplan", {
			id: parseInt(id),
		})
			.then((resp) => {
				buildData(resp.data)
				props.loadingStatus(false)
			})
			.catch((e) => {
				console.log(e)
				props.loadingStatus(false)
			})
	}

	const validation = () => {
		return Yup.object().shape({
			sqft: Yup.number().required("Required"),
			stories: Yup.number().required("Required"),
			beds: Yup.number().required("Required"),
			full_baths: Yup.number().required("Required"),
			garage: Yup.number().required("Required"),
		})
	}

	const onDrop = (files, f, type) => {
		const req = request.post(`${settings.ep}/inputFloorplanImage`)
		req.attach(files[0].name, files[0])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.field("attributes", JSON.stringify({ floorplan_id: id }))
		req.field("type", type)
		req.end((err, response) => {
			//return
			let resp = response.body
			//console.log(resp)
			//return
			if (err) {
				console.log(err)
			}
			if (resp.status == 200) {
				toast.success(resp.message)
				f.setFieldValue("files", resp.data)
				setImages(resp.data)
			}
		})
	}

	const removeImage = (k, f, type) => {
		let imgs = _.clone(images)
		imgs.splice(k, 1)
		setImages(imgs)
		f.setFieldValue("files", imgs)
		props.loadingStatus(true)
		let values = {
			images,
			type: "floorplan",
			id,
		}
		submitData("removeImage", values).then((data) => {
			toast.success(data.message)
			props.loadingStatus(false)
		})
	}

	const compileThumbs = (f, type) => {
		const arrayMove = require("array-move")
		const onChange = (sourceId, sourceIndex, targetIndex) => {
			//console.log(sourceId, sourceIndex, targetIndex)
			let imgs = _.clone(images)
			imgs = arrayMove(imgs, sourceIndex, targetIndex)
			setImages(imgs)
			f.setFieldValue("files", imgs)
		}
		let rows = Math.ceil(images.length / 4)
		let height = rows * 235
		return (
			<GridContextProvider onChange={onChange}>
				<GridDropZone
					id="items"
					boxesPerRow={6}
					rowHeight={225}
					style={{ height: `${height}px`, width: "100%" }}>
					{images.map((item, k) => {
						let url
						if (item.url && item.url.includes("http")) {
							url = item.url
						} else {
							url = `${settings.s3}${item}`
						}
						// Parantheses in filename break image thumbnail
						url = url.replace(/\(/g, "%28").replace(/\)/g, "%29")
						let icon = (
							<div
								className="imageZone__thumb"
								key={`thumb` + item}
								style={{
									backgroundImage: `url(${url})`,
								}}>
								<i
									className="fas fa-times-circle formFiles__removeIcon"
									onClick={() => removeImage(k, f, type)}></i>
							</div>
						)
						return (
							<GridItem key={k} className="imageZone__block">
								<div
									style={{
										width: "100%",
										height: "100%",
										paddingBottom: "20px",
										paddingRight: "20px",
									}}>
									{icon}
								</div>
							</GridItem>
						)
					})}
				</GridDropZone>
			</GridContextProvider>
		)
	}

	const buildClassifications = (f) => {
		if (props.payload?.public?.floorplan_classifications?.length === 0) return null
		let classifications = []
		_.forEach(props.payload.public.floorplan_classifications, (v) => {
			classifications.push({ label: v.name, value: v.id })
		})
		if (classifications.length > 0) {
			return (
				<li className={fieldStatus("classifications", f)}>
					<label htmlFor="classifications">Classifications</label>
					{f.errors.classifications && f.touched.classifications && (
						<div className="form__message">{f.errors.classifications}</div>
					)}
					<ReactSelect
						name={`classifications`}
						options={classifications}
						isMulti
						value={f.values.classifications}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				</li>
			)
		}
		return null
	}
	if (!loaded) return null
	return (
		<>
			<Title title={`Floorplan: ${fields.name}`} showDate={false} />
			<div className="content">
				<Formik
					enableReinitialize
					initialValues={fields}
					validationSchema={validation}
					validateOnMount={true}
					onSubmit={(values) => {
						props.loadingStatus(true)
						//console.log(values)
						//return
						values.id = id
						let type = "entry"
						if (location.pathname.includes("/arc/")) type = "arc"
						submitData("updateFloorplan", values).then((data) => {
							//return
							props.loadingStatus(false)
							toast.success(data.message)
							history.push(`/${type}/floorplans`)
						})
					}}>
					{(f) => (
						<div className="">
							<Form>
								{/* console.log(f) */}
								<ul className="form__list">
									{!settings.arc ||
										(settings?.enabled?.allowSalesRepsEditFloorplan && (
											<>
												<li className={fieldStatus("name", f)}>
													<label htmlFor="name">
														Name <sup>*</sup>
													</label>
													{f.values.name}
												</li>
												<li className={fieldStatus("sqft", f)}>
													<label htmlFor="sqft">
														Square Feet<sup>*</sup>
													</label>
													{f.errors.sqft && f.touched.sqft && (
														<div className="form__message">{f.errors.sqft}</div>
													)}
													<NumberField
														name="sqft"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.sqft}
														error={f.errors.sqft}
														value={f.values.sqft}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("stories", f)}>
													<label htmlFor="stories">
														Stories<sup>*</sup>
													</label>
													{f.errors.stories && f.touched.stories && (
														<div className="form__message">{f.errors.stories}</div>
													)}
													<NumberField
														name="stories"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.stories}
														error={f.errors.stories}
														value={f.values.stories}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("beds", f)}>
													<label htmlFor="beds">
														Beds<sup>*</sup>
													</label>
													{f.errors.beds && f.touched.beds && (
														<div className="form__message">{f.errors.beds}</div>
													)}
													<NumberField
														name="beds"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.beds}
														error={f.errors.beds}
														value={f.values.beds}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("full_baths", f)}>
													<label htmlFor="full_baths">
														Full Baths<sup>*</sup>
													</label>
													{f.errors.full_baths && f.touched.full_baths && (
														<div className="form__message">{f.errors.full_baths}</div>
													)}
													<NumberField
														name="full_baths"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.full_baths}
														error={f.errors.full_baths}
														value={f.values.full_baths}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("half_baths", f)}>
													<label htmlFor="half_baths">Half Baths</label>
													{f.errors.half_baths && f.touched.half_baths && (
														<div className="form__message">{f.errors.half_baths}</div>
													)}
													<NumberField
														name="half_baths"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.half_baths}
														error={f.errors.half_baths}
														value={f.values.half_baths}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("garage", f)}>
													<label htmlFor="garage">
														Garage<sup>*</sup>
													</label>
													{f.errors.garage && f.touched.garage && (
														<div className="form__message">{f.errors.garage}</div>
													)}
													<NumberField
														name="garage"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.garage}
														error={f.errors.garage}
														value={f.values.garage}
														thousandSeparator={true}
													/>
												</li>
												{buildClassifications(f)}
												<li className={fieldStatus("description", f)}>
													<label htmlFor="description">Description</label>
													{f.errors.description && f.touched.description && (
														<div className="form__message">{f.errors.description}</div>
													)}
													<TextArea
														name="description"
														className="form__textarea"
														value={f.values.description}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.description}
														error={f.errors.description}
													/>
												</li>
											</>
										))}
									<li className={fieldStatus("files", f, false, false, true)}>
										<label htmlFor="files">Images</label>
										{f.errors.files && f.touched.files && (
											<div className="form__message">{f.errors.files}</div>
										)}
										<Dropzone
											multiple={false}
											onDrop={(files) => {
												onDrop(files, f, "general")
											}}>
											{({ getRootProps, getInputProps }) => (
												<section className="dropzone">
													<div {...getRootProps()} className="dropbox__cont">
														<input {...getInputProps()} />
														<p className="dropzone__action">
															Drag 'n' drop file here, or click to select files
														</p>
													</div>
												</section>
											)}
										</Dropzone>
									</li>
									<li className={fieldStatus("base_prices", f, false, false, true)}>
										<div className="reportGroup">
											<h3>Base Prices by Community</h3>
											<KeyValueField
												options={{
													key: {
														type: "select",
														lookup: "properties",
														header: "Property",
													},
													value: {
														type: "number",
														header: "Base Price",
													},
												}}
												data={f.values.base_prices}
												delete={true}
												onChange={(v) => f.setFieldValue("base_prices", v)}
											/>
										</div>
									</li>
									<li className="form__listItem form__listItem--full">
										<div className="formFiles">
											<h3>General Images</h3>
											<div className="formFiles__listCont">{compileThumbs(f, "general")}</div>
										</div>
									</li>
								</ul>
								<input type="submit" value="Submit" className={helpers.submitClasses(f.isValid)} />
							</Form>
						</div>
					)}
				</Formik>
			</div>
		</>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Floorplan)
